const NotificationIcon = () => {
  return (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.41797 18.5C9.34664 18.7041 9.22842 18.8888 9.05859 19.0586C8.75996 19.3572 8.41633 19.5 8 19.5C7.58367 19.5 7.24004 19.3572 6.94141 19.0586C6.77158 18.8888 6.65336 18.7041 6.58203 18.5H9.41797ZM8 0.5C8.28557 0.5 8.51218 0.5942 8.70898 0.791016C8.90581 0.987858 9 1.21445 9 1.5V2.45605L9.39746 2.53906C10.6278 2.7973 11.6091 3.4259 12.3613 4.43652C13.1211 5.4573 13.5 6.60653 13.5 7.90039V16H15.5V16.5H0.5V16H2.5V7.90039C2.5 6.60653 2.87894 5.4573 3.63867 4.43652C4.39093 3.4259 5.37221 2.7973 6.60254 2.53906L7 2.45605V1.5C7 1.21445 7.09419 0.987858 7.29102 0.791016C7.48782 0.5942 7.71443 0.5 8 0.5ZM8 2.90039C6.61891 2.90039 5.42882 3.38954 4.45898 4.35938C3.48928 5.32917 3 6.51939 3 7.90039V16H13V7.90039C13 6.51939 12.5107 5.32917 11.541 4.35938C10.5712 3.38954 9.38109 2.90039 8 2.90039Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default NotificationIcon;
